import { InstanceData, InstanceDataType } from '@/framework/data';
import { OperateServer } from './operate-server';

export class Operate extends OperateServer {
    constructor(identity: string) {
        super(identity);
    }

    destroy() {
        super.destroy();
    }
}

export function getOperateInstance(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.Operate) as Operate;
}
